<form>
  <nb-card class="form">
    <nb-card-header
      ><h4>{{ title | translate }}</h4></nb-card-header
    >
    <nb-card-body>
      <p>{{ message | translate }}</p>
      <nb-radio-group
        *ngIf="options?.length"
        class="confirm-options"
        [(ngModel)]="selectedOption"
        [ngModelOptions]="{ standalone: true }"
      >
        <nb-radio *ngFor="let option of options" [value]="option.value">
          <span class="confirm-options__label">{{ option.label | translate }}</span>
          <span *ngIf="option.description" class="confirm-options__desc">
            {{ option.description | translate }}
          </span>
        </nb-radio>
      </nb-radio-group>
      <nb-form-field *ngIf="inputLabel" class="confirm-input">
        <input
          nbInput
          fullWidth
          type="text"
          [attr.aria-label]="inputLabel | translate"
          [placeholder]="inputPlaceholder | translate"
          [maxlength]="inputMaxLength"
          [(ngModel)]="inputValue"
          [ngModelOptions]="{ standalone: true }"
        />
      </nb-form-field>
      <p class="confirm-details" *ngIf="details">{{ details | translate }}</p>
      <nb-checkbox
        *ngIf="showSuppress"
        class="confirm-suppress"
        [(ngModel)]="suppress"
        [ngModelOptions]="{ standalone: true }"
      >{{ suppressLabel | translate }}</nb-checkbox>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        [status]="cancelStatus"
        outline
        (click)="dialogRef.close(false)"
      >
        {{ cancelLabel | translate }}
      </button>
      <button
        [nbSpinner]="loading"
        type="submit"
        nbButton
        [status]="confirmStatus"
        [disabled]="loading"
        (click)="onDialogConfirm()"
      >
        {{ confirmLabel | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
